import { memoize } from "@use/decorators";

import { urls } from "@courses-pm2/api/src/ts/config";
import { getStandardPageCount, getTextContent } from "@courses-pm2/api/src/ts/utils";

import { CaptionedContentElementData, CaptionedContentElementModel } from "@courses-pm2/api/src/ts/models/elements/CaptionedContentElementModel";

/**
 * Specification of data needed to instantiate a new AccordionModel.
 */
export type VideoData = {
    [K in "displayInternalInfo" | "photoId" | "token"]: VideoModel[K];
};

/**
 * Describes the content to be rendered for the element, so that it's made
 * easily available.
 */
export class VideoModel extends CaptionedContentElementModel {
    public readonly photoId: string;
    public readonly token: string;


    /**
     * Specifies if internal info (ie. title and description) should be rendered
     * inside the audio player.
     */
    public readonly displayInternalInfo?: boolean;

    /**
     * Apply data given when a new model is being instantiated.
     */
    constructor(initial: VideoData & CaptionedContentElementData) {
        super(initial);

        this.photoId = initial.photoId;
        this.token = initial.token;
        this.displayInternalInfo = initial.displayInternalInfo;
    }

    /**
     * There's no preview images available for audio files.
     */
    @memoize()
    public async getPreviewImageUrl(): Promise<string | undefined> {
        return undefined;
    }

    /**
     * @inheritdoc
     *
     * Due to the nature of the calculation of standard pages, media elements
     * aren't counted on their own. We do however include the caption of the
     * element in the calculations.
     */
    // tslint:disable-next-line: completed-docs
    @memoize()
    public getStandardPageCount(): number {
        return getStandardPageCount(getTextContent(this.getCaptionText()));
    }
}
